const ts = {
  GRID_HEADER_NAME: {
    description: "Employee Name in Grid Header",
    primaryValue: "Name",
    stringKey: "GRID_HEADER_NAME",
  },
  GRID_HEADER_EMAIL: {
    description: "Email in Grid Header",
    primaryValue: "Email",
    stringKey: "GRID_HEADER_EMAIL",
  },
  ACCESS_TEXT: {
    description: "Access in Grid Header",
    primaryValue: "Access",
    stringKey: "ACCESS_TEXT",
  },
  GRID_HEADER_STATUS: {
    description: "Status in Grid Header",
    primaryValue: "Status",
    stringKey: "GRID_HEADER_STATUS",
  },
  HEADER_BAR_MY_PASSES: {
    description: "My Passes in Header Bar",
    primaryValue: "My Passes",
    stringKey: "HEADER_BAR_MY_PASSES",
  },
  MYSTORE_ONLINEBENEFITS_TEXT:{
    description: "My Store and Online Benefits Text",
    primaryValue: "My Store & Online Benefits",
    stringKey: "MYSTORE_ONLINEBENEFITS_TEXT",
  },
  MANAGEMYACCESS_TEXT: {
    description: "Manage My Access Button",
    primaryValue: "Manage My Access",
    stringKey: "MANAGEMYACCESS_TEXT",
  },
  PASS_STATUS_INACTIVE: {
    description: "Inactive Status",
    primaryValue: "Inactive",
    stringKey: "PASS_STATUS_INACTIVE",
  },
  PASS_STATUS_REGISTERED: {
    description: "Registered Status",
    primaryValue: "Registered",
    stringKey: "PASS_STATUS_REGISTERED",
  },
  PASS_STATUS_USED: {
    description: "Used Status",
    primaryValue: "Used",
    stringKey: "PASS_STATUS_USED",
  },
  PASS_STATUS_SUSPENDED: {
    description: "Suspended Status",
    primaryValue: "Suspended",
    stringKey: "PASS_STATUS_SUSPENDED",
  },
  PASS_STATUS_PENDING: {
    description: "Pending Status",
    primaryValue: "Pending",
    stringKey: "PASS_STATUS_PENDING",
  },
  PASS_STATUS_EXPIRED: {
    description: "Expired Status",
    primaryValue: "Expired",
    stringKey: "PASS_STATUS_EXPIRED",
  },
  PASS_STATUS_DENIED: {
    description: "Denied Status",
    primaryValue: "Denied",
    stringKey: "PASS_STATUS_DENIED",
  },
  PASS_STATUS_DECLINED: {
    description: "Declined Status",
    primaryValue: "Declined",
    stringKey: "PASS_STATUS_DECLINED",
  },
  PASS_STATUS_CHECKED_IN: {
    description: "Checked In Status",
    primaryValue: "Checked In",
    stringKey: "PASS_STATUS_CHECKED_IN",
  },
  PASS_STATUS_CANCELED: {
    description: "Canceled Status",
    primaryValue: "Canceled",
    stringKey: "PASS_STATUS_CANCELED",
  },
  MYACCESS_MANAGESTORE_TEXT: {
    description: "Manage Store Text",
    primaryValue: "Manage Your Store & Online Account Benefits",
    stringKey: "MYACCESS_MANAGESTORE_TEXT",
  },
  SELECT_APPLY_TEXT: {
    description: "Select Apply Text",
    primaryValue: "(Select all that apply)",
    stringKey: "SELECT_APPLY_TEXT",
  },
  REQUESTEDACCESS_TEXT: {
    description: "Requested Access Text",
    primaryValue: "Requested Access",
    stringKey: "REQUESTEDACCESS_TEXT",
  },
  MANAGERAAPROVAL_SWOOSHONLY_MODAL_TEXT: {
    description: "Manager Approval Swoosh Only Modal Text",
    primaryValue:
      "Please note: Manager approval is only required for Swoosh.com access",
    stringKey: "MANAGERAAPROVAL_SWOOSHONLY_MODAL_TEXT",
  },
  BTN_UPDATE: {
    description: "Update Button",
    primaryValue: "Update",
    stringKey: "BTN_UPDATE",
  },
  ACCOUNT_LINKED: {
    description: "Account Linked",
    primaryValue: "Account Linked",
    stringKey: "ACCOUNT_LINKED",
  },
  LINKACCOUNT_TEXT_P1: {
    description: "I hereby consent to",
    primaryValue: "I hereby consent to",
    stringKey: "LINKACCOUNT_TEXT_P1",
  },
  LINKACCOUNT_TEXT_LINK: {
    description: "Swoosh Terms and Conditions",
    primaryValue: "Swoosh Terms and Conditions",
    stringKey: "LINKACCOUNT_TEXT_LINK",
  },
  LINKACCOUNT_TEXT_P2: {
    description:
      "and consent to linking my Nike member account to access Swoosh.",
    primaryValue:
      "and consent to linking my Nike member account to access Swoosh.",
    stringKey: "LINKACCOUNT_TEXT_P2",
  },
  LINK_ACCOUNT: {
    description: "Link Account",
    primaryValue: "Link Account",
    stringKey: "LINK_ACCOUNT",
  },
  SAVING_TEXT:{
    description: "Saving Text",
    primaryValue: "Saving",
    stringKey: "SAVING_TEXT",
  },
  TOASTR_CHANGES_SAVED:{
    description: "Changes Saved",
    primaryValue: "Changes Saved",
    stringKey: "TOASTR_CHANGES_SAVED",
  },
  TOASTR_PASS_ERROR:{
    description: "Error while saving",
    primaryValue: "Error while saving",
    stringKey: "TOASTR_PASS_ERROR",
  }
};

export default ts;
